import { render } from "./CustomerDelete.vue?vue&type=template&id=edf5532a&ts=true"
import script from "./CustomerDelete.vue?vue&type=script&lang=ts"
export * from "./CustomerDelete.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__